import Grid from "@mui/material/Grid";
import React from "react";
import PropTypes from "prop-types";
import _get from "lodash/get";
import moment from "moment-timezone";
import { withStyles } from "@mui/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import TablePagination from "@mui/material/TablePagination";
import NotFoundTableRow from "../NotFoundTableRow";
import PersonIcon from "@mui/icons-material/Person";
import PhoneIcon from "@mui/icons-material/LocalPhone";
import EmailIcon from "@mui/icons-material/Email";
import Button from "@mui/material/Button";
import ViewAccountDetail from "./ViewAccountDetail";
import { ADMIN_CONFIG } from "../../config/index";
import { LABELS as _LABELS } from "../../language";
const LABELS = _LABELS.adminPage;

const styles = (theme) => ({
  root: {
    maxWidth: "98%",
    marginRight: "auto",
    marginLeft: "auto",
    marginTop: theme.spacing(1.5),
    overflowX: "auto",
  },
  table: {
    minWidth: 700,
  },
  capitalize: {
    textTransform: "capitalize",
  },
  icon: {
    color: "#009be5",
    fontSize: 16,
    marginBottom: -2,
    width: 25,
  },
  title: {
    fontWeight: 600,
    margin: "10px auto 5px",
  },
  EditIcon: {
    color: "#009be5",
    cursor: "pointer",
  },
  dataXLargeRow: {
    minWidth: 190,
  },
  dataLargeRow: {
    minWidth: 150,
  },
  dataMedRow: {
    minWidth: 110,
  },
  dataSmallRow: {
    minWidth: 90,
  },
  button: {
    marginTop: 2,
    minWidth: 95,
  },
});

class ReduxTableRow extends React.Component {
  render() {
    const { isStripe, classes, isPayment, item = {} } = this.props;
    const planDues = _get(item, "plan.dues", []);
    const planName = _get(item, "plan.plan.name", "Standard");

    return (
      <TableRow hover>
        <TableCell component="th" scope="row">
          <div className={classes.dataLargeRow}>
            <div
              style={{ color: "#009ddc", cursor: "pointer" }}
              onClick={(e) => this.props.handleAccountDetails(item)}
            >
              <strong>{item.name}</strong>
            </div>
            <div>{item.allowed}</div>
            <div>{item.email}</div>
          </div>
        </TableCell>
        <TableCell>{item.status}</TableCell>
        <TableCell>{planName}</TableCell>
        <TableCell>
          {item.contact && item.contact.name && (
            <div className={classes.dataLargeRow}>
              {item.contact.name && (
                <div className={classes.capitalize}>
                  {item.contact.name} ({item.contact.role})
                </div>
              )}
              {item.contact.email && <div>{item.contact.email}</div>}
              {item.contact.phone && <div>Ph: {item.contact.phone}</div>}
            </div>
          )}
        </TableCell>
      </TableRow>
    );
  }
}

export class AccountTable extends React.Component {
  state = { open: false, selectedAccount: null, order: "asc" };

  handleChangePage = (event, page) => {
    const { limit } = this.props;
    this.props.handleChange({ page, limit });
  };

  handleChangeRowsPerPage = (event) => {
    const limit = event.target.value;
    const { page } = this.props;
    this.props.handleChange({ page, limit });
  };

  handleDetails = async (selectedAccount) => {
    this.setState({ loading: true });
    this.setState({ open: true });
    this.props.selectedAccount(selectedAccount);
    const accountId = selectedAccount._id;
    await this.props.getAccountDetails({ accountId });
    this.setState({ loading: false });
  };

  handleClose = () => {
    this.setState({ open: false });
    this.props.selectedAccount(null);
  };

  render() {
    const { eld, classes, items = [], count = 1000 } = this.props;
    const { page, limit } = this.props;

    const { open, loading } = this.state;
    const isPayment = ADMIN_CONFIG.payments;
    return (
      <Grid container>
        <Grid item xs={12} sm={12} md={12}>
          <ViewAccountDetail
            open={open}
            handleClose={this.handleClose}
            loading={loading}
          />
          <Paper className={classes.root}>
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell>{LABELS.name}</TableCell>
                  <TableCell>{LABELS.status}</TableCell>
                  <TableCell>{"Plan"}</TableCell>
                  <TableCell>{LABELS.contact}</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {Array.isArray(items) &&
                  items.map((item, i) => (
                    <ReduxTableRow
                      item={item}
                      key={i}
                      eld={eld}
                      isPayment={isPayment}
                      classes={classes}
                      handleDetails={this.handleDetails}
                      handleEdit={this.props.handleEdit}
                      formatDate={this.props.formatDate}
                      isStripe={this.props.isStripe}
                      handleAccountDetails={this.props.handleAccountDetails}
                    />
                  ))}
              </TableBody>
            </Table>
            <NotFoundTableRow items={items} />
            <TablePagination
              rowsPerPageOptions={[10, 25, 50, 100, 500, 1000]}
              component="div"
              count={count}
              rowsPerPage={limit}
              page={page}
              onPageChange={this.handleChangePage}
              onRowsPerPageChange={this.handleChangeRowsPerPage}
              labelRowsPerPage={LABELS.rowsperpage}
            />
          </Paper>
        </Grid>
      </Grid>
    );
  }
}

AccountTable.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(AccountTable);
